import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { useAuth } from '../hooks/useAuth'
import type { League } from '../lib/types'
import InstallPrompt from '../components/InstallPrompt'

interface Row extends League {
  member_count: number
  units_total: number
}

export default function Dashboard() {
  const { signOut } = useAuth()
  const [leagues, setLeagues] = useState<Row[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    ;(async () => {
      const { data } = await supabase
        .from('league_members')
        .select('units_total, leagues(*)')
        .order('joined_at', { ascending: false })

      const rows = (data ?? []).map((r: any) => ({
        ...r.leagues,
        units_total: r.units_total,
        member_count: 0,
      })) as Row[]
      setLeagues(rows)
      setLoading(false)
    })()
  }, [])

  return (
    <div className="page">
      <header className="topbar">
        <Link className="wordmark" to="/app">GRIDLOCK</Link>
        <div className="row gap">
          <Link className="btn btn-ghost" to="/app/join">Join</Link>
          <Link className="btn btn-primary" to="/app/new">New league</Link>
          <button className="btn btn-ghost" onClick={signOut}>Sign out</button>
        </div>
      </header>

      <main className="container">
        <h1>Your leagues</h1>
        {loading && <p className="muted">Loading…</p>}
        {!loading && leagues.length === 0 && (
          <div className="card empty">
            <p>No leagues yet.</p>
            <div className="row gap">
              <Link className="btn btn-primary" to="/app/new">Start one</Link>
              <Link className="btn btn-ghost" to="/app/join">Join with a code</Link>
            </div>
          </div>
        )}
        <div className="grid">
          {leagues.map((l) => (
            <Link key={l.id} to={`/app/l/${l.id}`} className="card league-card">
              <h3>{l.name}</h3>
              <p className="muted">
                {l.season_id} · {l.roster_slots.join(' / ')}
              </p>
              <p className="units">{l.units_total} units</p>
              <code className="code">{l.join_code}</code>
            </Link>
          ))}
        </div>
      </main>
      <InstallPrompt />
    </div>
  )
}
